module.exports = __webpack_public_path__ + "static/media/logical-or.7539af7f.png";